import {
  ArrayMinSize,
  IsDefined,
  IsInt,
  IsOptional,
  IsString,
  Length,
  ValidateNested
} from 'class-validator';
import { Type } from 'class-transformer';

export class AclStockPermissionListCreateDto {
  @IsDefined()
  @IsString()
  @Length(1, 255)
  name: string;

  @IsOptional()
  @IsString()
  @Length(1, 500)
  tags: string;

  @IsDefined()
  @IsInt()
  sourceMerchantId: number;

  @IsDefined()
  @ArrayMinSize(1)
  @ValidateNested({each: true})
  @Type(() => StockPermission)
  stockPermissions: StockPermission[];

  @IsDefined()
  @ArrayMinSize(1)
  @ValidateNested({each: true})
  @Type(() => MerchantPermission)
  merchantPermissions: MerchantPermission[];
}

export class AclStockPermissionListUpdatePermissionsDto {
  @IsDefined()
  @IsInt()
  stockPermissionListId: number;

  @IsDefined()
  @ArrayMinSize(1)
  @ValidateNested({each: true})
  @Type(() => StockPermission)
  stockPermissions: StockPermission[];

  @IsDefined()
  @ArrayMinSize(1)
  @ValidateNested({each: true})
  @Type(() => MerchantPermission)
  merchantPermissions: MerchantPermission[];
}

export class StockPermission {
  @IsDefined()
  @IsInt()
  stockEntityId: number;

  @IsDefined()
  @IsInt()
  supplierEntityId: number;
}

export class MerchantPermission {
  @IsDefined()
  @IsInt()
  targetMerchantId: number;
}
